import type { Enums } from "../types";

export const INVOICE_TYPES: Enums<"outgoingInvoiceType">[] = [
	"single-invoice",
	"progress-invoice",
	"final-invoice",
];
